import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FlamingoHttpService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.baseUrl}${environment.apiBasePath}`;

    get<T>(endpoint: string, params?: Record<string, string | number | boolean>): Observable<T> {
        return this.http.get<T>(this.url(endpoint), { params: this.toHttpParams(params) });
    }

    post<T>(endpoint: string, body: unknown): Observable<T> {
        return this.http.post<T>(this.url(endpoint), body);
    }

    postWithParams<T>(
        endpoint: string,
        body: unknown,
        params?: Record<string, string | number | boolean>
    ): Observable<T> {
        return this.http.post<T>(this.url(endpoint), body, { params: this.toHttpParams(params) });
    }

    postFormData<T>(endpoint: string, formData: FormData): Observable<T> {
        return this.http.post<T>(this.url(endpoint), formData);
    }

    put<T>(endpoint: string, body: unknown): Observable<T> {
        return this.http.put<T>(this.url(endpoint), body);
    }

    putFormData<T>(endpoint: string, formData: FormData): Observable<T> {
        return this.http.put<T>(this.url(endpoint), formData);
    }

    patch<T>(endpoint: string, body: unknown): Observable<T> {
        return this.http.patch<T>(this.url(endpoint), body);
    }

    delete<T>(endpoint: string): Observable<T> {
        return this.http.delete<T>(this.url(endpoint));
    }

    deleteVoid(endpoint: string): Observable<void> {
        return this.http.delete<void>(this.url(endpoint));
    }

    download(endpoint: string, params?: Record<string, string | number | boolean>): Observable<Blob> {
        return this.http.get(this.url(endpoint), {
            params: this.toHttpParams(params),
            responseType: 'blob'
        });
    }

    private url(endpoint: string): string {
        const sanitized = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
        const fullUrl = `${this.baseUrl}${sanitized}`;
        console.log('[FlamingoHttpService] Request URL:', fullUrl, '| baseUrl:', this.baseUrl, '| endpoint:', sanitized);
        return fullUrl;
    }

    private toHttpParams(
        params?: Record<string, string | number | boolean>
    ): HttpParams | undefined {
        if (!params) {
            return undefined;
        }

        return Object.entries(params).reduce(
            (acc, [key, value]) => acc.append(key, String(value)),
            new HttpParams()
        );
    }
}


